import React from 'react';
import { UseQueryResult } from '@tanstack/react-query';
import { useApiQuery } from 'api/use-api-query';
import { useGetPeriodsInActivity } from 'api/activities';
import { API_NAMES } from 'api/constants';
import { EntityTypeItem, PeriodsApi, TagItem } from 'oas';
import { PeriodTemplate, PeriodTemplateAllowedTagType, PeriodTemplatesApi } from 'oas/internal';

export const useGetPeriodTemplates = (options = {}): UseQueryResult<EntityTypeItem[]> => {
    return useApiQuery(
        ['periods', 'templates'],
        (apiConfig, axiosInstance) => new PeriodsApi(apiConfig, '', axiosInstance).getPeriodEntityTypeItems(),
        {
            staleTime: 30 * 60_000,
            ...options,
        },
    );
};

export const useGetPeriodTemplateList = (options = {}): UseQueryResult<PeriodTemplate[]> => {
    return useApiQuery(
        ['period-templates'],
        (apiConfig, axiosInstance) => new PeriodTemplatesApi(apiConfig, '', axiosInstance).getPeriodTemplates(),
        options,
        'internal',
        API_NAMES.ACTIVITY_SERVICE,
    );
};

export const useGetPeriodTemplateAllowedTagTypes = (options = {}): UseQueryResult<PeriodTemplateAllowedTagType[]> => {
    return useApiQuery(
        ['period-templates', 'allowed-tag-types'],
        (apiConfig, axiosInstance) =>
            new PeriodTemplatesApi(apiConfig, '', axiosInstance).getPeriodTemplateAllowedTagTypes(),
        options,
        'internal',
        API_NAMES.ACTIVITY_SERVICE,
    );
};

export const usePeriodTags = (activityId: string | undefined, periodId: string | undefined): TagItem[] => {
    const { data: periods } = useGetPeriodsInActivity(activityId ?? '');

    return React.useMemo(() => {
        if (!activityId || !periodId || !periods) {
            return [];
        }
        return periods.find((p) => p.id === periodId)?.tags ?? [];
    }, [activityId, periodId, periods]);
};
